<template>
  <div>
    <div class="owner_title">接单中心</div>
    <div class="btn_box">
      <div class="filtrate_btn">
        <el-button
          class="order_select_btn"
          type="primary"
          :plain="btn_active == 0 ? false : true"
          @click="allBtn(0)"
          >全部</el-button
        >
        <el-button
          type="primary"
          class="order_select_btn"
          :plain="btn_active == 1 ? false : true"
          @click="submitBtn(1)"
          >已提交</el-button
        >
        <el-button
          type="primary"
          class="order_select_btn"
          :plain="btn_active == 2 ? false : true"
          @click="employBtn(2)"
          >已录用</el-button
        >
      </div>
      <div class="filtrate" @click="show_filter_form()">
        <i class="iconfont icon-shaixuan1"></i>
        <span>筛选</span>
      </div>
    </div>
    <!-- 筛选表单 -->
    <div class="filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="金主编辑" prop="nickname">
          <el-input v-model="filter_form.nickname"></el-input>
        </el-form-item>
        <el-form-item label="任务要求" prop="ask">
          <el-input v-model="filter_form.ask"></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="filter_form.createtime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="goSearch"
          >搜索</el-button
        >
      </el-form>
    </div>

    <!-- pc端表格数据 -->
    <el-table
      v-show="equipmentType == 0 ? true : false"
      height="600"
      class="table_box order_table"
      :data="dataShow"
      border
      style="width: 98%"
    >
      <el-table-column type="index" label="序号" align="center" width="50">
      </el-table-column>
      <el-table-column
        property="nickname"
        label="金主编辑"
        align="center"
        sortable
        width="250"
      >
      </el-table-column>
      <el-table-column
        property="name"
        label="书名"
        align="center"
        sortable
        width="450"
      >
      </el-table-column>
      <el-table-column
        property="ask"
        label="任务要求"
        align="center"
        sortable
        width="450"
      >
      </el-table-column>
      <el-table-column
        property="writer_cost"
        label="给写手千字价格"
        align="center"
        sortable
        width="200"
      >
      </el-table-column>
      <el-table-column
        property="receive_num"
        label="已接人数"
        align="center"
        sortable
        width="130"
      >
      </el-table-column>
      <el-table-column
        property="trial_draft_num"
        label="已给试稿数"
        align="center"
        width="140"
        sortable
      >
      </el-table-column>
      <el-table-column
        property="createtime"
        label="创建时间"
        align="center"
        sortable
        width="200"
      >
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="320">
        <template slot-scope="scope">
          <div id="control_btn">
            <div @click="downloadFile(scope.row)" class="order_btn">
              <i class="iconfont icon-xiazai"></i>
              <span>提取文件</span>
            </div>
            <el-upload
              class="upload-demo"
              :action="uploadUrl"
              multiple
              :on-success="uploadFile"
              :show-file-list="false"
            >
              <div class="order_btn" @click="upload(scope.row)">
                <i class="el-icon-circle-check"></i>
                <span> 上传文件</span>
              </div>
            </el-upload>

            <!-- "employ": 0//0-录用结果 1-录用选择写手 -1未录用 -->
            <el-tag
              class="order_tag"
              :type="
                scope.row.employ == '0'
                  ? ''
                  : scope.row.employ == '1'
                  ? 'success'
                  : 'danger'
              "
              @click="employDialogBtn(scope.row)"
            >
              {{
                scope.row.employ == "0"
                  ? "录用结果"
                  : scope.row.employ == "1"
                  ? "录用选择写手"
                  : "未录用"
              }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!--移动端表格数据 -->
    <div class="task_box" v-show="equipmentType == 1 ? true : false">
      <el-table :data="dataShow" border height="800">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="nickname"
          label="金主编辑"
          align="center"
          sortable
          width="101"
        >
        </el-table-column>
        <el-table-column
          property="name"
          label="书名"
          align="center"
          sortable
          width="101"
        >
        </el-table-column>
        <el-table-column
          property="ask"
          label="任务要求"
          align="center"
          sortable
          width="101"
        >
        </el-table-column>
        <el-table-column
          property="writer_cost"
          label="给写手千字价格"
          align="center"
          sortable
          width="160"
        >
        </el-table-column>
        <el-table-column
          property="receive_num"
          label="已接人数"
          align="center"
          sortable
          width="110"
        >
        </el-table-column>
        <el-table-column
          property="trial_draft_num"
          label="已给试稿数"
          align="center"
          width="120"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="createtime"
          label="创建时间"
          align="center"
          sortable
          width="110"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="110">
          <template slot-scope="scope">
            <div id="control_btn">
              <div @click="downloadFile(scope.row)" class="order_btn">
                <i class="iconfont icon-xiazai"></i>
                <span>提取文件</span>
              </div>
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                multiple
                :on-success="uploadFile"
                :show-file-list="false"
              >
                <div class="order_btn" @click="upload(scope.row)">
                  <i class="el-icon-circle-check"></i>
                  <span> 上传文件</span>
                </div>
              </el-upload>

              <!-- "employ": 0//0-录用结果 1-录用选择写手 -1未录用 -->
              <el-tag
                class="order_tag"
                :type="
                  scope.row.employ == '0'
                    ? ''
                    : scope.row.employ == '1'
                    ? 'success'
                    : 'danger'
                "
                @click="employDialogBtn(scope.row)"
              >
                {{
                  scope.row.employ == "0"
                    ? "录用结果"
                    : scope.row.employ == "1"
                    ? "录用选择写手"
                    : "未录用"
                }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pagination_box"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <!-- 选择写手 -->
    <el-dialog
      class="dialog_input"
      title="选择写手"
      :visible.sync="employDialogVisible"
      :width="dialogWidth"
      center
    >
      <el-form :model="employForm" class="menuscript_form_dialog">
        <el-form-item label="选择写手:">
          <el-select
            v-model="employForm.nickname"
            placeholder="请选择"
            filterable
            @change="getWriter($event)"
          >
            <el-option
              v-for="item in writerList"
              :key="item.id"
              :label="item.nickname"
              :value="{
                id: item.id,
                writer_expand_id: item.writer_expand_id,
                nickname: item.nickname
              }"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog_btn" round type="primary" @click="submitEmloy"
          >确认</el-button
        >
        <el-button class="dialog_btn" round @click="employDialogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import {
  order_taking_list,
  upload_file,
  writer_tabulation,
  define_writer,
  draw_file
} from "@/utils/writer";
export default {
  data() {
    return {
      baseUrl: this.$global.commonUrl, //路径
      uploadUrl: this.$global.fileUploadUrl, //文件上传路径
      writerId: "", //所属写手部id
      orderList: [], //任务数据列表
      writerList: [], //写手列表
      isFilterForm: true, //筛选表单
      dialogWidth: "30%", //弹窗宽度
      employDialogVisible: false, //录用结果弹窗
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      currentUploadId: "", //当前上传的id
      // 筛选
      filter_form: {
        nickname: "", //金主编辑
        name: "", //书名
        ask: "", //任务要求
        createtime: "" //创建时间
      },
      employForm: {
        writer_id: "", //写手id
        nickname: "",
        connectionessay_id: "", //文章id
        writer_expand_id: "" //写手扩展id
      },
      btn_active: 0, //按钮默认选中
      select_time_data: "",
      time_filter: "", //时间筛选
      equipmentType: 0 //判断移动端还是pc端  0：pc  1：移动
    };
  },
  created() {
    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;
    this.getOrderList();
    this.getWriterList();
  },
  mounted() {
    var that = this;
    // 根据不同路由跳转不同页面
    if (that.isMobile()) {
      //  手机端
      that.dialogWidth = "70%";
      that.equipmentType = 1;
    } else {
      //  pc端
      that.dialogWidth = "30%";
      that.equipmentType = 0;
    }
  },
  methods: {
    // 获取接单中心列表
    getOrderList() {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        page: 1,
        page_index: 10
      };
      order_taking_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.orderList = res.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 判断是移动端还是PC端
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    // 获取文件上传的id
    upload(val) {
      var that = this;

      that.currentUploadId = val.id;
    },
    // 文件上传
    uploadFile(val) {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        connectionessay_id: that.currentUploadId,
        appendix_files: val.data.url
      };
      upload_file(obj).then(res => {
        if (res.data.code == 1) {
          that.$message.success(res.data.msg);
          that.goSearch();
          // that.getOrderList();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 获取写手列表
    getWriterList() {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        page: 1,
        page_index: 10
      };
      writer_tabulation(obj).then(res => {
        if (res.data.code == 1) {
          that.writerList = res.data.data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 获取写手列表的id
    getWriter(val) {
      var that = this;
      that.employForm.writer_id = val.id;
      that.employForm.nickname = val.nickname;
      that.employForm.writer_expand_id = val.writer_expand_id;
    },
    // 筛选
    goSearch() {
      var that = this;
      // var date1 = that.filter_form.createtime[0];
      // var date2 = that.filter_form.createtime[1];
      // var time;
      var date1, date2;
      that.select_time_data = that.filter_form.createtime;
      date1 = that.select_time_data[0];
      date2 = that.select_time_data[1];

      if (date1 == undefined && date2 == undefined) {
        that.time_filter = "";
      } else {
        that.time_filter = date1 + " - " + date2;
      }
      console.log("that.time_filter", that.time_filter);
      that.filter_form.createtime = that.time_filter;
      let obj = {
        departmentuser_id: that.writerId,
        page: 1,
        page_index: 10,
        ...that.filter_form
      };
      order_taking_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.orderList = res.data.data;
          that.calcPageData();
          that.filter_form.createtime = that.select_time_data;
          console.log(" that.filter_form", that.filter_form);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    //录用结果
    employDialogBtn(val) {
      if (val.employ != 1) {
        return false;
      }
      var that = this;
      that.employDialogVisible = true;
      that.employForm.connectionessay_id = val.id;
      that.goSearch();
      // that.getOrderList();
    },
    // 确认选中写手
    submitEmloy() {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId, //所属写手部id
        ...that.employForm
      };
      define_writer(obj).then(res => {
        if (res.data.code == 1) {
          // that.getOrderList();
          that.goSearch();
          that.$message.success(res.data.msg);
        } else {
          that.$message.error(res.data.msg);
        }
        that.employDialogVisible = false;
      });
    },
    // 筛选方法
    getData(val) {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        status: val,
        page: 1,
        page_index: 10
      };
      order_taking_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.orderList = res.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 全部
    allBtn(val) {
      var that = this;
      that.btn_active = 0;
      that.getData(val);
    },
    // 已提交
    submitBtn(val) {
      var that = this;
      that.btn_active = 1;
      that.getData(val);
    },
    // 已录用
    employBtn(val) {
      var that = this;
      that.btn_active = 2;
      that.getData(val);
    },
    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 提取文件

    downloadFile(val) {
      var that = this;
      var xurl = val.xurl;
      var file = val.file;
      var fileName = val.filename;
      console.log("提取文件", xurl);

      if (val.file == "") {
        this.$message.error("暂无可下载文件");
      } else {
        var obj = {
          departmentuser_id: that.writerId,
          connectionessay_id: val.id
        };
        draw_file(obj).then(res => {
          if (res.data.code == 1) {
            if (that.equipmentType == 0) {
              // pc端
              var url = that.baseUrl + file;
              var link = document.createElement("a");
              link.style.display = "none";
              link.href = url;
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
            } else {
              // 移动端
              var url = that.baseUrl + xurl;
              var link = document.createElement("a");
              link.style.display = "none";
              link.href = url;
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              console.log("移动端", link);
              link.click();
              window.URL.revokeObjectURL(link.href);
              document.body.removeChild(link);
            }

            this.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    // 计算页数的方法
    calcPageData() {
      if (this.orderList.length > 1) {
        this.pageNum = Math.ceil(this.orderList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.orderList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    }
  }
};
</script>
<style scoped>
.el-input__inner {
  background-color: RGB(250, 250, 250);
}
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}
/* 筛选表单 */
.filter_form {
  /* width: 1655px; */
  /* height: 60px; */
  background: #ffffff;
  margin: 0px 15px;
  padding-top: 15px;
}
.btn_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 15px 15px 10px 15px;
}
.addInfo,
.filtrate i {
  font-size: 14px;
}
.filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}

.table_box {
  margin: 0px 15px;
}
.el-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 20px;
  border-radius: 10px;
}

.tag_circle {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #e2170f;
  margin-right: 5px;
}
#control_btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  flex-flow: wrap;
}

.order_table .order_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  border-radius: 10px;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  margin-left: 5px;
  margin-bottom: 5px;
}
.order_table .order_btn i {
  font-size: 12px;
}

.order_table .order_tag_btn {
  width: 90px;
  height: 35px;
  line-height: 35px;
  padding: 5px 10px;
  text-align: center;
  line-height: 5px;
  border-radius: 15px;
  /* display: initial; */
}
.order_tag {
  width: 100px;
  border: none;
  margin-left: 5px;
}
.order_table .el-button:focus,
.el-button:hover {
  color: #fff;
  border-color: #c6e2ff;
  background-color: #157df8;
}
.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.el-dialog__header {
  background: #157df8;
}
.el-dialog__title {
  color: #fff;
}

.el-dialog--center .el-dialog__body {
  padding: 25px 70px 30px;
}
.dialog-footer .dialog_btn {
  width: 200px;
  height: 35px;
}
.checkbox {
  display: flex;
  flex-direction: column;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .order_select_btn {
    width: 70px !important;
  }
  /* .order_table .order_btn {
    width: 30px;
    height: 20px;
  }
  .order_tag {
    width: 90px;
    margin-top: 5px;
  } */
  .dialog-footer .dialog_btn {
    width: 100px;
  }
  .task_box {
    margin: 0px 15px;
    margin-bottom: 150px;
  }

  #control_btn .order_btn {
    width: 90px;
    height: 20px;
    line-height: 20px;
    background: #e7f2ff;
    border-radius: 10px;
    font-size: 12px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #157df8;
    margin-left: 5px;
    margin-bottom: 5px;
  }
  #control_btn .order_btn i {
    font-size: 12px;
  }
}
.order_select_btn {
  width: 100px;
  height: 30px;
  line-height: 7px;
  border-radius: 4px;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/view/writer/OrderCenter.vue